(function () {

  let isLoaded = false;
  let isLoading = false;
  let callbacks = [];

  window.loadGoogleMaps = function (callback) {
    if (window.google && window.google.maps) {
      isLoaded = true;
      callback && callback();
      return;
    }

    if (callback) callbacks.push(callback);
    if (isLoading) return;

    isLoading = true;

    const mapKey = window.getAPIUrl && window.getAPIUrl('mapKey');

    if (!mapKey) {
      console.error('Google Maps API key missing');
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${mapKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = function () {
      isLoaded = true;
      isLoading = false;

      callbacks.forEach(cb => cb && cb());
      callbacks = [];
    };

    document.head.appendChild(script);
  };


  function initAutocomplete() {
    const inputs = document.querySelectorAll('[data-autocomplete-enabled="true"]');
    if (!inputs.length) return;

    inputs.forEach(input => {
      if (input.dataset.mapInit === 'true') return;
      input.dataset.mapInit = 'true';

      const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['(cities)'],
        componentRestrictions: { country: 'in' }
      });

      autocomplete.addListener('place_changed', function () {
        const place = autocomplete.getPlace();

        if (!place.address_components) return;

        let pincode = '';

        place.address_components.forEach(c => {
          if (c.types.includes('postal_code')) {
            pincode = c.long_name;
          }
        });

        if (pincode) {
          const form = input.closest('form');
          const pinInput = form?.querySelector('[name="Pin"]');
          if (pinInput) pinInput.value = pincode;
        }
      });
    });
  }


  function initMapsIfNeeded() {
    const inputs = document.querySelectorAll('[data-autocomplete-enabled="true"]');
    if (!inputs.length) return;

    window.loadGoogleMaps(initAutocomplete);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMapsIfNeeded);
  } else {
    initMapsIfNeeded();
  }

})();